export enum FormControlType {
  CHECKBOX = 'CHECKBOX',
  INPUT = 'INPUT'
}
export interface Column {
  name: string,
  hide?: boolean,
  label?: string
  pipe?: any;
  formControl?: FormControlType,
  valueControl?: FormControlType,
  pipeParam?: any | any[],
  hideOnMobile?: boolean,
  mobileViewDetails?: {
    column: number,
    row: number
  }
  dataType?: string;
  prefix?: string;
  sufix?: string;
  isHtml?: boolean;
  style?: (row?: any) => any;
  mobileStyle?: (row?: any) => any;
  iconBefore?: string;
  iconBeforeStyle?: (row?: any) => any;
  iconAfter?: string;
  iconAfterStyle?: (row?: any) => any;
  width?: string
  padding?: string;
  maxWidth?: string
  mMaxWidth?: string
  sMaxWidth?: string
  showTooltip?: boolean
}

export interface Row {
  id: string;
  isDisabled?: boolean;
  isSelected?: boolean;
}

export interface Page<T> {
  content: T[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable:
    {
      pageNumber: number; pageSize: number; sort: {
        empty: boolean
        sorted: boolean;
        unsorted: boolean
      }, offset: number; paged: boolean
    };
  size: number;
  sort: { empty: boolean, sorted: boolean, unsorted: boolean };
  totalElements: number;
  totalPages: number;
}
